module.exports = __webpack_public_path__ + "img/preschool-english-sertif-small.16dceab6.jpg";